export default {

    /* 判断是否是移动端 */
    _isMobile: function() {
        return (/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone|Safari)/i).test(navigator.userAgent)
    },

    _isPc: function() {
        var userAgentInfo = navigator.userAgent
        var Agents = ['Android', 'iPhone',
            'SymbianOS', 'Windows Phone',
            'iPad', 'iPod']
        var flag = true
        for (var v = 0; v < Agents.length; v++) {
            if (userAgentInfo.indexOf(Agents[v]) > 0) {
                flag = false
                break
            }
        }
        return flag
    }

}



// WEBPACK FOOTER //
// ./src/lib/common.js